import { g as r } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as s, normalizeClass as d, createElementVNode as a, createStaticVNode as p } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const h = {
  name: "DtIconMicrosoftTeams",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (i) => Object.keys(l).includes(i)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], m = ["fill"], v = ["id"], M = ["id"];
function Z(i, t, o, C, _, e) {
  return n(), s("svg", {
    "aria-label": o.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--microsoft-teams"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Microsoft Teams",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${i.uniqueID}a)`
    }, [
      t[0] || (t[0] = p('<path d="M15.95 9.977h5.166c.488 0 .884.395.884.883v4.706a3.248 3.248 0 0 1-3.248 3.248h-.015a3.248 3.248 0 0 1-3.249-3.248v-5.127c0-.255.207-.462.462-.462Zm3.492-.93a2.093 2.093 0 1 0 0-4.187 2.093 2.093 0 0 0 0 4.187Z" fill="#5059C9"></path><path d="M12.93 9.047a3.023 3.023 0 1 0 0-6.047 3.023 3.023 0 0 0 0 6.047Zm4.031.93H8.434a.874.874 0 0 0-.853.894v5.367a5.246 5.246 0 0 0 5.117 5.367 5.246 5.246 0 0 0 5.116-5.367v-5.367a.874.874 0 0 0-.853-.894Z" fill="#7B83EB"></path><path opacity=".1" d="M13.163 9.977v7.52a.856.856 0 0 1-.851.852H7.99a5.664 5.664 0 0 1-.41-2.112V10.87a.873.873 0 0 1 .852-.893h4.73Z" fill="currentColor"></path><path opacity=".2" d="M12.698 9.977v7.986a.857.857 0 0 1-.851.851H8.209a6.021 6.021 0 0 1-.218-.465 5.664 5.664 0 0 1-.41-2.112V10.87a.873.873 0 0 1 .852-.893h4.265Z" fill="currentColor"></path><path opacity=".2" d="M12.698 9.977v7.056a.858.858 0 0 1-.851.85h-4.02a5.665 5.665 0 0 1-.246-1.646V10.87a.873.873 0 0 1 .852-.893h4.265Z" fill="currentColor"></path><path opacity=".2" d="M12.233 9.977v7.056a.858.858 0 0 1-.852.85H7.828a5.665 5.665 0 0 1-.247-1.646V10.87a.873.873 0 0 1 .852-.893h3.8Z" fill="currentColor"></path><path opacity=".1" d="M13.163 7.572v1.465c-.08.005-.154.01-.233.01-.079 0-.153-.005-.232-.01a2.552 2.552 0 0 1-.465-.074 3.023 3.023 0 0 1-2.094-1.777 2.582 2.582 0 0 1-.148-.465h2.32c.47.002.85.382.852.851Z" fill="currentColor"></path><path opacity=".2" d="M12.698 8.037v1a2.553 2.553 0 0 1-.465-.074 3.024 3.024 0 0 1-2.094-1.777h1.708a.853.853 0 0 1 .85.851Z" fill="currentColor"></path><path opacity=".2" d="M12.698 8.037v1a2.553 2.553 0 0 1-.465-.074 3.024 3.024 0 0 1-2.094-1.777h1.708a.853.853 0 0 1 .85.851Z" fill="currentColor"></path><path opacity=".2" d="M12.233 8.037v.926a3.023 3.023 0 0 1-2.094-1.777h1.242c.47.002.85.382.852.851Z" fill="currentColor"></path>', 10)),
      a("path", {
        d: "M2.853 7.186h8.527c.47 0 .852.382.852.853v8.527c0 .47-.381.853-.852.853H2.853A.853.853 0 0 1 2 16.566V8.039c0-.471.382-.853.853-.853Z",
        fill: `url(#${i.uniqueID}b)`
      }, null, 8, m),
      t[1] || (t[1] = a("path", {
        d: "M9.36 10.432H7.655v4.641H6.57v-4.641H4.873v-.9H9.36v.9Z",
        fill: "#fff"
      }, null, -1))
    ], 8, u),
    a("defs", null, [
      a("linearGradient", {
        id: `${i.uniqueID}b`,
        x1: "3.778",
        y1: "6.52",
        x2: "10.455",
        y2: "18.085",
        gradientUnits: "userSpaceOnUse"
      }, [...t[2] || (t[2] = [
        a("stop", { "stop-color": "#5A62C3" }, null, -1),
        a("stop", {
          offset: ".5",
          "stop-color": "#4D55BD"
        }, null, -1),
        a("stop", {
          offset: "1",
          "stop-color": "#3940AB"
        }, null, -1)
      ])], 8, v),
      a("clipPath", {
        id: `${i.uniqueID}a`
      }, [...t[3] || (t[3] = [
        a("path", {
          fill: "#fff",
          transform: "translate(2 3)",
          d: "M0 0h20v18.605H0z"
        }, null, -1)
      ])], 8, M)
    ])
  ], 10, f);
}
const b = /* @__PURE__ */ c(h, [["render", Z]]);
export {
  b as default
};
//# sourceMappingURL=microsoft-teams.js.map
